import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Alert } from 'antd';
import { fetchAlertApp } from 'store/fetchActions/fetchApp';
import * as S from './styles';

export const ComponentAlert = () => {
  const dispatch = useDispatch();

  const dadosAlerta = useSelector(state => state.app.alertApp);

  const onClose = () => {
    dispatch(fetchAlertApp({ tipo: false, mensagem: false }));
  };

  return (
    <>
      {dadosAlerta?.mensagem && (
        <S.Container id="ComponenteAlert">
          <S.ContainerAlert>
            <Alert message={dadosAlerta?.mensagem} type={dadosAlerta?.tipo} showIcon closable onClose={onClose} />
          </S.ContainerAlert>
        </S.Container>
      )}
    </>
  );
};

export default ComponentAlert;
